import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable, MASK_DECIMAL } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _ImpFreightRate, _PriceListFreightRate } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { EditorPriceList } from "../../../../Factoty&Production/PriceList/EditorPriceList";
import { TransportServiceType } from "../../TransportService/TransportServiceType";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { CurrencyEditor } from "../../../../erp/cellEditor/Currency/CurrencyEditor";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { FileInput } from "../../../../theme/Component/FileInput";
import { EditorTransportRoute } from "../../TransportRoute/EditorTransportRoute";
import { DropDown } from "../../../../theme/Component/DropDown";
import useModal, { MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";


export const PriceListFreightRate = () => {

    const listrate = useDataBean(_PriceListFreightRate);
    const imprate = useDataBean(_ImpFreightRate);
    const paginador = usePaginator();
    const [form, setForm] = useState<any>({
        TransportRoute: null,
        TransportRouteName: null,
    });
    const [listaAll, setListaAll] = useState<any>([]);
    const modalDownload = useModal("Consolidado", MODAL_SM);
    const [PrieceList, setPrieceList] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [ServiceType, setServiceType] = useState<number>(null)
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltarifaadd, setModaltarifaadd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        listrate.instance.getPriceListFreightRateCatalog(form.TransportRoute, PrieceList, ServiceType, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)

                }
            }
        )

    }
    const getListaAll = () => {

        listrate.instance.getPriceListFreightRateCatalog(form.TransportRoute, PrieceList, ServiceType, paginador.page, 15 * paginador.pages).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setListaAll(resp.List)

                }
            }
        )

    }
    const create = () => {
        listrate.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        listrate.instance.deletePriceListFreightRate(listrate.bean.IDPriceListFreightRate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        listrate.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addtarifa = () => {
        listrate.setBean({

        });
        setModaltarifaadd({ ...modaltarifaadd, "view": true });
    }
    const head = [
        { title: 'ID', property: 'IDPriceListFreightRate', visible: true },
        { title: 'Año Lista de Precios', property: 'PriceListYear', visible: true },
        { title: 'Activo', property: 'PriceListIsActive', visible: true },
        { title: 'Código Lista de Precios', property: 'PriceListCode', visible: true },
        { title: 'Nombre Lista de Precios', property: 'PriceListName', visible: true },
        { title: 'Tipo de Transporte de Carga', property: 'TransportTypeName', visible: true },
        { title: 'Orígen', property: 'TransportDestinationOrigin', visible: true },
        { title: 'Destino', property: 'TransportDestinationDestinity', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_DECIMAL },
        { title: 'Básico Correo', property: 'MailBasic', visible: true },
        { title: 'Kg Correo', property: 'MailKg', visible: true },
        { title: 'Básico Carga', property: 'FreightBasic', visible: true },
        { title: 'Kg Carga', property: 'FreightKg', visible: true },
        { title: 'Básico Carga Especial', property: 'SpecialFreightBasic', visible: true },
        { title: 'Kg Carga Especial', property: 'SpecialFreightKg', visible: true },
        { title: 'Básico Volumen', property: 'VolumeFreightCm2', visible: true },
        { title: 'Cm2 Volumen', property: 'SpecialVolumeFreightCm2', visible: true },
        { title: 'Moneda', property: 'CurrencyCode', visible: true },
        { title: 'Modifica', property: 'EmployeeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar Tarifa', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const addPriceListFreightRate = () => {
        listrate.instance.addPriceListFreightRate(listrate.bean.IDPriceList, listrate.bean.IDTransportRoute, listrate.bean.TransportType, listrate.bean.IDCurrency, listrate.bean.Value, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp);
                toast.success("Tarifa agregada correctamente");
                setModaltarifaadd({ ...modaltarifaadd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const importFreightRate = () => {
        //console.log(entailment.bean);
        imprate.instance.importFreightRate(imprate.bean.IDPriceList, imprate.bean.IDCurrencyType, imprate.bean.Media, imprate.bean.MediaContext, null).then(
            (resp: any) => {
                getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const veradd = () => {
        setModaladd({ ...modaladd, "view": true });

    }
    const actionsDropDown = [
        { id: 1, name: 'Descargar Reporte', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            getListaAll();
                            modalDownload.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }
    return (
        <BasicPage titulo="Tarifas de Transporte de Carga">
            <div className="row">
                <div className="col-md-6">
                    <EditorTransportRoute render={form.TransportRouteName} idSelector={form.TransportRoute} onChange={(e) => { setForm({ ...form, "TransportRoute": e.IDTransportRoute, "TransportRouteName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <EditorPriceList onChange={(e) => { setPrieceList(e.IDPriceList) }} label="Listado de precios" />
                </div>
                <div className="col-md-6">
                    <TransportServiceType idSelector={ServiceType} onChange={(e) => { setServiceType(e) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-fill" eventClick={addtarifa}>Agregar Tarifa</BasicButton>
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={veradd}>
                        Importar Tarifas
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={listrate.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Valor</label>
                                <input type="text" name="Value" className="form-control" value={listrate.bean.Value} onChange={(e) => { listrate.setBean({ ...listrate.bean, "Value": e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label>Básico Correo</label>
                                <input name="MailBasic" className="form-control" value={listrate.bean.MailBasic} onChange={(e) => { listrate.setBean({ ...listrate.bean, "MailBasic": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Kg Correo</label>
                                <input name="MailKg" className="form-control" value={listrate.bean.MailKg} onChange={(e) => { listrate.setBean({ ...listrate.bean, "MailKg": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Básico Carga</label>
                                <input name="FreightBasic" className="form-control" value={listrate.bean.FreightBasic} onChange={(e) => { listrate.setBean({ ...listrate.bean, "FreightBasic": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Kg Carga</label>
                                <input name="FreightKg" className="form-control" value={listrate.bean.FreightKg} onChange={(e) => { listrate.setBean({ ...listrate.bean, "FreightKg": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Básico Carga Especial</label>
                                <input name="MailKg" className="form-control" value={listrate.bean.SpecialFreightBasic} onChange={(e) => { listrate.setBean({ ...listrate.bean, "SpecialFreightBasic": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Kg Carga Especial</label>
                                <input name="SpecialFreightKg" className="form-control" value={listrate.bean.SpecialFreightKg} onChange={(e) => { listrate.setBean({ ...listrate.bean, "SpecialFreightKg": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Básico Volumen</label>
                                <input name="VolumeFreightCm2" className="form-control" value={listrate.bean.VolumeFreightCm2} onChange={(e) => { listrate.setBean({ ...listrate.bean, "VolumeFreightCm2": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Cm2 Volumen</label>
                                <input name="SpecialVolumeFreightCm2" className="form-control" value={listrate.bean.SpecialVolumeFreightCm2} onChange={(e) => { listrate.setBean({ ...listrate.bean, "SpecialVolumeFreightCm2": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <CurrencyEditor id={listrate.bean.IDCurrency} onchange={(e: any) => { listrate.setBean({ ...listrate.bean, "IDCurrency": e }) }}></CurrencyEditor>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaltarifaadd} updateModal={setModaltarifaadd} eventModal={addPriceListFreightRate}>
                        <div className="row">
                            <div className="col-md-12">
                                <EditorPriceList onChange={(e: any) => { listrate.setBean({ ...listrate.bean, "IDPriceList": e.IDPriceList }) }} label="Listado de precios" />
                            </div>
                            <div className="col-md-6">
                                <TransportServiceType idSelector={listrate.bean.TransportType} onChange={(e: any) => { listrate.setBean({ ...listrate.bean, "TransportType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <EditorTransportRoute render={listrate.bean.TransportRouteName} idSelector={listrate.bean.IDTransportRoute} onChange={(e) => { listrate.setBean({ ...listrate.bean, "IDTransportRoute": e.IDTransportRoute, "TransportRouteName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <CurrencyEditor id={listrate.bean.IDCurrency} onchange={(e: any) => { listrate.setBean({ ...listrate.bean, "IDCurrency": e }) }}></CurrencyEditor>
                            </div>
                            <div className="col-md-6">
                                <label>Valor</label>
                                <InputMoney _value={listrate.bean.Value} onChange={(e) => { listrate.setBean({ ...listrate.bean, "Value": e }) }} />
                                {/* <input type="number" name="Value" className="form-control" value={listrate.bean.Value} onChange={(e) => { listrate.setBean({ ...listrate.bean, "Value": e.target.value }) }} /> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {listaAll.length > 0 &&
                                    <ExportXLSL customName={'incapacidades'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaladd} updateModal={setModaladd} eventModal={importFreightRate}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <EditorPriceList onChange={(e: any) => { imprate.setBean({ ...imprate.bean, "IDPriceList": e.IDPriceList }) }} label="Listado de precios" />
                                </div>
                                <div className="col-md-12">
                                    <CurrencyEditor id={imprate.bean.IDCurrencyType} onchange={(e: any) => { imprate.setBean({ ...imprate.bean, "IDCurrencyType": e }) }}></CurrencyEditor>
                                </div>
                                <div className="col-md-12">
                                    <FileInput
                                        Media={imprate.bean.Media}
                                        MediaContext={imprate.bean.MediaContext}
                                        directory='Rate'
                                        label='Archivo'
                                        docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                        onCreate={(Filemap: any) => { imprate.setBean({ ...imprate.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                    ></FileInput>
                                </div>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {listrate.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}